<template>
  <div>
    <v-switch
      :label="$t('incidentReports.incidentReportFormLong.trainee')"
      v-model="value.trainee"
    ></v-switch>
  </div>
</template>
<script>
export default {
  props: ["value"],
  data: () => ({}),
  methods: {},
};
</script>
